import React, { useState, useEffect, useRef } from "react";
import { Box, Typography, Button } from "@mui/material";
import lectors from "../../data/lectors";
import Robo from "../../assets/profile/robo.png";
import Beata from "../../assets/profile/beata.png";
import Martin from "../../assets/profile/martin.png";
import Tomas from "../../assets/profile/tomas.png";
import Radek from "../../assets/profile/radek-kitner.png";
import FormCourse from "../global/FormCourse";
import FormKontaktGlobal from "../global/FormKontaktGlobal";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import icon from "../../assets/skolenie_ikona_orangeyellow_stroke_rozklik.svg";
import { Link } from "react-router-dom";
import {fontType} from "../../constants/font";
import {courses} from "../../data/courses";
import CourseDescription from "./CourseDescription";

const Description = ({
  courseId,
  isFormOpen,
  handleFormOpen,
  isSelectedDate,
  courseCode,
  price,
  terms,
  courseName,
  duration,
  certification,
}) => {
  const [dates, setDates] = useState([]);

  useEffect(() => {
    if (terms) {
      let startDates = [];
      for (let i = 0; i < terms.length; i++) {
        startDates.push(terms[i].date_from);
      }
      setDates(startDates);
    }
  }, [terms]);

  useEffect(() => {
    if (isFormOpen) {
      document.body.style.overflow = "hidden";
    }

    if (!isFormOpen) {
      document.body.style.overflow = "visible";
    }
  });
  const course = courses.find((obj) => obj.code === courseCode);

  const returnPhoto = (id) => {
    var image;
    id = Number(id);
    switch (id) {
      case 1:
        image = Robo;
        break;
      case 2:
        image = Beata;
        break;
      case 3:
        image = Martin;
        break;
      case 6:
        image = Tomas;
          break;
      case 9:
        image = Radek;
        break;
    }
    return image;
  };

  const [products, inViewProducts] = useInView({
    triggerOnce: true, // Only trigger the animation once when scrolled into view
  });

  // close on click on bg
  const background = useRef(null);
  const backgroundTop = useRef(null);
  const handleClick = (e) => {
    if (e.target.id === "bg" || e.target.id === "bgTop") handleFormOpen();
  };

  return (
    <Box
      sx={{
        backgroundColor: "#d8d8d8",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* purple bar */}
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#7b7cd5",
          position: "relative",
          height: "91px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          style={{ position: "absolute", width: "226px", top: -45 }}
          src={icon}
          alt="student_hat"
        />
      </Box>
      {/* detail */}
      <Box
        sx={{
          maxWidth: "1440px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            marginLeft: { md: "9vw", xs: "20px" },
            marginRight: { md: "9vw", xs: "20px" },
            marginTop: "100px",
            justifyContent: "space-between",
            width: "100%",
            zIndex: 2,
            flexDirection: { md: "row", xs: "column" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              maxWidth: { md: "50%", xs: "unset" },
            }}
          >
            <Typography
              sx={{
                color: "#1d1a56",
                fontFamily: fontType.semiBold,
                fontSize: "33px",
                lineHeight: "39px",
                marginRight: "50px",
              }}
            >
              {courseName}
            </Typography>
            <Typography
              sx={{
                color: "#1d1a56",
                fontFamily: fontType.regular,
                fontSize: "38px",
                lineHeight: "44px",
                textAlign: "start",
                marginBottom: "15px",
              }}
            >
              {duration}
            </Typography>
            <Box
              sx={{
                display: "flex",
                maxWidth: "700px",
                flexWrap: "wrap",
                justifyContent: "start",
                marginBottom: "15px",
              }}
            >
              {course?.tags.map((tag, index) => {
                return (
                  <Typography
                    key={index}
                    sx={{
                      border: "2px solid",
                      borderColor: "#7b7cd5",
                      borderRadius: "16px",
                      color: "#1d1a56",
                      fontFamily: fontType.regular,
                      fontSize: { md: 14, xs: 13 },
                      lineHeight: "29px",
                      paddingLeft: "7px",
                      paddingRight: "9px",
                      minHeight: "31px",
                      marginRight: "2px",
                      marginBottom: "6px",
                      display: "flex",
                      textAlign: "center",
                    }}
                  >
                    {tag}
                  </Typography>
                );
              })}
            </Box>
          </Box>
          <Box
            sx={{
              maxWidth: { md: "50%", xs: "undefined" },
              width: "100%",
              justifyContent: "space-between",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: { md: "center", xs: "center" },
                marginLeft: { md: "50px", xs: "0" },
              }}
            >
              {course?.lectors.map((id, index) => {
                const lector = lectors.find(lector => parseInt(lector.id) === id);
                const lectorIndex = lectors.findIndex(lector => parseInt(lector.id) === id);

                return (
                  <Link
                    to={`/skolenia?lector=${lectorIndex}#lectors`}
                    style={{ textDecoration: "none" }}
                  >
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        marginBottom: "17px",
                        minWidth: "205px",
                      }}
                    >
                      {['1', '2', '3', '9'].includes(lector.id) ? (
                        <Box
                          sx={{
                            borderRadius: "50%",
                            backgroundImage: `url(${returnPhoto(
                                lector.id
                            )})`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            width: "80px",
                            height: "80px",
                            display: "flex",
                            position: "relative",
                            alignItems: "center",
                          }}
                        ></Box>
                      ) : null}
                      {lector.id == 6 ? (
                        <Box
                          sx={{
                            borderRadius: "50%",
                            width: "80px",
                            height: "80px",
                            display: "flex",
                            position: "relative",
                            alignItems: "center",
                            backgroundColor: "#5a5ccc",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            style={{
                              position: "absolute",
                              bottom: -3,
                              right: 7,
                              borderRadius: "50%",
                              width: "70px",
                              height: "70px",
                            }}
                            src={require("../../assets/profile/tomas.png")}
                            alt="tomas"
                          />
                        </Box>
                      ) : null}
                      {lector.id == 5 ? (
                        <Box
                          sx={{
                            borderRadius: "50%",
                            width: "80px",
                            height: "80px",
                            display: "flex",
                            position: "relative",
                            alignItems: "center",
                            backgroundColor: "#5a5ccc",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            style={{
                              position: "absolute",
                              bottom: -10,
                              borderRadius: "50%",
                              width: "80px",
                              height: "80px",
                            }}
                            src={require("../../assets/profile/daniel.png")}
                            alt="daniel"
                          />
                        </Box>
                      ) : null}

                      {lector.id == 4 ? (
                        <Box
                          sx={{
                            borderRadius: "50%",
                            width: "80px",
                            height: "80px",
                            display: "flex",
                            position: "relative",
                            alignItems: "center",
                            backgroundColor: "#5a5ccc",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            style={{
                              position: "absolute",
                              bottom: -5,
                              left: 5,
                              borderRadius: "50%",
                              width: "64px",
                              height: "80px",
                            }}
                          />
                        </Box>
                      ) : null}

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          marginLeft: "14px",
                          marginRight: "14px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: fontType.regular,
                            fontSize: 16,
                            color: "#1d1a56",
                            lineHeight: "19px",
                          }}
                        >
                          {lector.name}
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: fontType.regular,
                            fontSize: 12,
                            lineHeight: "19px",
                            color: "#1d1a56",
                          }}
                        >
                          {lector.role}
                        </Typography>
                      </Box>
                    </Box>
                  </Link>
                );
              })}
            </Box>
            {/* button */}
            <Box
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: "right",
                alignItems: "end",
              }}
            >
              {!course?.showPrice ? (
                <Button
                  onClick={handleFormOpen}
                  sx={{
                    borderRadius: "28px",
                    backgroundColor: "#eba62c",
                    fontFamily: fontType.semiBold,
                    fontSize: 25,
                    cursor: "pointer",
                    color: "white",
                    height: "44px",
                    width: "185px",
                    textTransform: "initial",
                    "&:hover": {
                      backgroundColor: "#3fcaea",
                    },
                  }}
                >
                  <span style={{ fontFamily: fontType.regular, fontSize: 18 }}>
                    {course?.isPractice ? "Zadarmo" : "Na požiadanie"}
                  </span>
                </Button>
              ) : (price) ? (
                <Button
                  onClick={handleFormOpen}
                  sx={{
                    borderRadius: "28px",
                    backgroundColor: "#eba62c",
                    fontFamily: fontType.semiBold,
                    fontSize: 25,
                    cursor: "pointer",
                    color: "white",
                    height: "44px",
                    minWidth: "185px",
                    paddingLeft: "20px",
                    paddingRight: "20px",
                    textTransform: "initial",
                    "&:hover": {
                      backgroundColor: "#3fcaea",
                    },
                  }}
                >
                  <span
                    style={{
                      fontFamily: fontType.regular,
                      fontSize: 18,
                      marginRight: "5px",
                    }}
                  >
                    Kúpiť za{" "}
                  </span>
                  {`${price} €`}
                  <span style={{ fontFamily: fontType.regular, fontSize: 18 }}>
                    * bez DPH
                  </span>
                </Button>
              ) : null}
            </Box>
          </Box>
        </Box>
        {isFormOpen && (
          <Box
            onClick={handleClick}
            id="bgTop"
            ref={backgroundTop}
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(128, 128, 128, 0.5)", // Grey color with 50% opacity
              overflow: "auto",
              zIndex: 50, // Set an appropriate z-index value
              justifyContent: "center",
            }}
          >
            <Box
              onClick={handleClick}
              id="bg"
              ref={background}
              sx={{
                display: "flex",
                justifyContent: "center",
                paddingTop: "50px",
                paddingBottom: "50px",
              }}
            >
              {(terms?.length < 1 || course?.code === 'internship') ? (
                  <FormKontaktGlobal
                      setContactForm={handleFormOpen}
                      contactMessage={course?.code === 'internship' ? "Mám záujem o praktickú stáž" : `Mám záujem o školenie ${courseName}`}
                  />
              ) : (
                  <FormCourse
                      datesArray={dates}
                      terms={terms}
                      onClose={handleFormOpen}
                      isSelectedDate={isSelectedDate}
                      courseName={courseName}
                      courseId={courseId}
                      certification={certification}
                  />
              )}
            </Box>
          </Box>
        )}
      </Box>
      {/* </motion.div> */}
      <motion.div
        ref={products}
        initial={{ opacity: 0, y: 50 }}
        animate={inViewProducts ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 0.7 }}
      >
        <CourseDescription course={course} />
      </motion.div>
    </Box>
  );
};

export default Description;
